"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPSDK = void 0;
const one_point_sdk_1 = __importDefault(require("@fozg/one-point-sdk"));
const develop_token = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiNWQ5MmNlMTExNzY3YTQwMjhiNDVkZmJiIiwidXNlcm5hbWUiOiJzdW5nIiwiZW1haWwiOiJmb3pnQG91dGxvb2suY29tIn0sImlhdCI6MTYxNDk1ODk5MH0.1yNdOcrmvC6iij9ccZLEpmJdYYMUi9FjsNy6BKPdZak`;
exports.OPSDK = new one_point_sdk_1.default("https://fozg.net/opapi", process.env.REACT_APP_TOKEN || develop_token);
//# sourceMappingURL=OnePointSDKBase.js.map